import { useSyncExternalStore } from 'react';
import { mobilePageTitleStore } from '../mobilePageTitleStore';

/** The entity name the page on screen gave the mobile top bar, if any. */
export function useMobilePageTitleValue(): string | undefined {
  return useSyncExternalStore(mobilePageTitleStore.subscribe, mobilePageTitleStore.get, mobilePageTitleStore.get);
}
